@if (configInputs) {
  <form class="simulate-form animated fadeIn" [formGroup]="simulatorForm" (ngSubmit)="simulate()">
    <div class="row">
      <div
        [ngClass]="{
          'col-12 col-lg-6 col-xl-4': isAdvanceSimulator,
          'col-12 col-md-6 col-lg-3': !isAdvanceSimulator,
        }"
      >
        <label
          [for]="configInputs?.propertyPrice?.id"
          [class.has-error]="
            simulatorForm?.controls?.propertyPrice?.touched && !simulatorForm?.controls?.propertyPrice?.valid
          "
          >{{ 'pre_simulator.property_price_label' | translate }}
          <a
            id="tooltip-propertyPrice"
            class="icon-a"
            href="javascript:void(0)"
            tooltipEvent="focus"
            [pTooltip]="'pre_simulator.property_price_info' | translate"
            (click)="openToast('tooltip-propertyPrice')"
          >
            <img class="ico-info" src="assets/img/info.svg" title="Haz clic para más información"
          /></a>
        </label>
        <slider-amount-input
          #propertyPriceInput
          [config]="configInputs.propertyPrice"
          formControlName="propertyPrice"
        ></slider-amount-input>

        @if (propertyPrice <= configInputs?.propertyPrice?.min) {
          <p class="has-error complementary-info">
            {{ 'simulator_info_min_price' | translate: { min: configInputs?.propertyPrice?.min | number: '1.0-0' } }}
          </p>
        }
      </div>
      <div
        [ngClass]="{
          'col-12 col-lg-6 col-xl-4': isAdvanceSimulator,
          'col-12 col-md-6 col-lg-3': !isAdvanceSimulator,
        }"
      >
        <label
          [for]="configInputs?.mortgageAmount?.id"
          [class.has-error]="
            simulatorForm?.controls?.mortgageAmount?.touched && !simulatorForm?.controls?.mortgageAmount?.valid
          "
          >{{ 'pre_simulator.mortgage_amount_label' | translate }}
          <a
            id="tooltip-mortgageAmount"
            class="icon-a"
            href="javascript:void(0)"
            tooltipEvent="focus"
            [pTooltip]="'pre_simulator.mortgage_amount_info' | translate"
            (click)="openToast('tooltip-mortgageAmount')"
          >
            <img class="ico-info" src="assets/img/info.svg" title="Haz clic para más información" /></a
        ></label>
        <slider-amount-input
          #mortgageAmountInput
          class="width-100"
          [config]="configInputs.mortgageAmount"
          formControlName="mortgageAmount"
        ></slider-amount-input>

        @if (mortgageAmount <= configInputs?.mortgageAmount?.min) {
          <p class="has-error complementary-info">
            {{
              'simulator_info_min_mortgage' | translate: { min: configInputs?.mortgageAmount?.min | number: '1.0-0' }
            }}
          </p>
        }
      </div>
      <div
        [ngClass]="{
          'col-12 col-lg-6 col-xl-4': isAdvanceSimulator,
          'col-12 col-md-6 col-lg-3': !isAdvanceSimulator,
        }"
      >
        <label
          [for]="configInputs?.termInYears?.id"
          [class.has-error]="
            simulatorForm?.controls?.termInYears?.touched && !simulatorForm?.controls?.termInYears?.valid
          "
        >
          {{ 'pre_simulator.term_in_years_label' | translate }}
          <a
            id="tooltip-termInYears"
            class="icon-a"
            href="javascript:void(0)"
            tooltipEvent="focus"
            [pTooltip]="'pre_simulator.term_in_years_info_mortgage_product_postpone' | translate"
            (click)="openToast('tooltip-termInYears')"
          >
            <img class="ico-info" src="assets/img/info.svg" title="Haz clic para más información" /></a
        ></label>
        <slider-amount-input
          #termInYearsInput
          class="width-100"
          [config]="configInputs.termInYears"
          formControlName="termInYears"
        ></slider-amount-input>
        @if (termInYears <= configInputs?.termInYears?.min) {
          <p class="has-error complementary-info">
            {{ 'simulator_info_min_years' | translate: { min: configInputs?.termInYears?.min | number: '1.0-0' } }}
          </p>
        }
      </div>

      @if (!isAdvanceSimulator) {
        <div
          [ngClass]="{
            'col-12 col-lg-6 col-xl-4': isAdvanceSimulator,
            'col-12 col-md-6 col-lg-3': !isAdvanceSimulator,
          }"
        >
          <label
            [for]="configInputs?.monthlyIncome?.id"
            [class.has-error]="
              simulatorForm?.controls?.monthlyIncome?.touched && !simulatorForm?.controls?.monthlyIncome?.valid
            "
          >
            {{ 'pre_simulator.monthly_income_label' | translate }}
            <a
              id="tooltip-monthlyIncome"
              class="icon-a"
              href="javascript:void(0)"
              tooltipEvent="focus"
              [pTooltip]="'pre_simulator.monthly_income_info' | translate"
              (click)="openToast('tooltip-monthlyIncome')"
            >
              <img class="ico-info" src="assets/img/info.svg" title="Haz clic para más información" /></a
          ></label>

          @if (!isAdvanceSimulator) {
            <slider-amount-input
              #monthlyIncomeInput
              class="width-100"
              [config]="configInputs.monthlyIncome"
              formControlName="monthlyIncome"
            ></slider-amount-input>
          }

          @if (isAdvanceSimulator) {
            <div class="disable">
              <input disabled class="form-control input-number" [value]="_userDataService.getTotalMonthlyIncome()" />
              <span class="number-span-euro">€</span>
            </div>
          }
        </div>
      }
      <div
        [ngClass]="{
          'col-12 col-lg-6 col-xl-4': isAdvanceSimulator,
          'col-12 col-md-6 col-lg-3': !isAdvanceSimulator,
        }"
      >
        <label
          for="select-location"
          [class.has-error]="simulatorForm?.controls?.location?.touched && !simulatorForm?.controls?.location?.valid"
          >{{ 'pre_simulator.ccaa_label' | translate }}</label
        >
        <select id="select-location" formControlName="location">
          <option *ngFor="let item of listCCAA" [value]="item?.id">
            {{ item.name }}
          </option>
        </select>
      </div>

      @if (!isAdvanceSimulator) {
        <div
          [ngClass]="{
            'col-12 col-lg-6 col-xl-4': isAdvanceSimulator,
            'col-12 col-md-6 col-lg-3': !isAdvanceSimulator,
          }"
        >
          <label for="appraisal-form-postalCode" [class.has-error]="postalCode.touched && !postalCode.valid">{{
            'postal_code_simulator' | translate
          }}</label>
          <input id="appraisal-form-postalCode" type="text" maxlength="5" minlength="5" [formControl]="postalCode" />
          <div class="error-content">
            @if ((postalCode.touched || postalCode?.value?.length === 5) && postalCode.hasError('pattern')) {
              <p class="has-error">
                {{ 'hipotecas_error_postal_code' | translate }}
              </p>
            }

            @if ((postalCode.touched || postalCode?.value?.length === 5) && postalCode.hasError('noValidPostalCode')) {
              <p class="has-error">
                {{ 'hipotecas_error_postal_code_unauthorized' | translate }}
              </p>
            }

            @if ((postalCode.touched || postalCode?.value?.length === 5) && postalCode.hasError('noValidPostalCode')) {
              <span class="ic ic-warning"></span>
            }
            @if (postalCode.valid && postalCode?.value?.length === 5) {
              <span class="ic ic-check"> </span>
            }
          </div>
        </div>
      }

      <div
        [ngClass]="{
          'col-12 col-xl-8': isAdvanceSimulator,
          'col-12 col-md-6': !isAdvanceSimulator,
        }"
      >
        <div class="switch-group-wrapper">
          <div class="switch-group">
            <label for="btn-new-home" class="switch-label">{{ 'pre_simulator.new_home_label' | translate }} </label>
            <label id="label-new-home" class="switch">
              <input
                type="checkbox"
                formControlName="isNewHome"
                id="btn-new-home"
                (change)="
                  onSendEvent({
                    event: 'interaccion',
                    eAction: 'vivienda nueva',
                    eLabel: simulatorForm?.controls?.isNewHome?.value === true ? 'Si' : 'No',
                  })
                "
              />
              <span class="slider round">
                <span>{{ 'yes' | translate }}</span>
                <span>{{ 'no' | translate }}</span>
              </span>
            </label>
            <a
              id="tooltip-newHome"
              class="icon-a"
              href="javascript:void(0)"
              tooltipEvent="focus"
              [pTooltip]="'pre_simulator.new_home_info' | translate"
              (click)="openToast('tooltip-newHome')"
            >
              <img class="ico-info" src="assets/img/info.svg" title="Haz clic para más información" />
            </a>
          </div>
          <div class="switch-group">
            <label for="btn-habitual-housing" class="switch-label"
              >{{ 'pre_simulator.habitual_housing_label' | translate }}
            </label>
            <label class="switch disable">
              <input type="checkbox" formControlName="isHabitualHousing" id="btn-habitual-housing" />
              <span class="slider round">
                <span> {{ 'yes' | translate }} </span>
                <span> {{ 'no' | translate }} </span>
              </span>
            </label>
            <a
              id="tooltip-habitualHousing"
              class="icon-a"
              href="javascript:void(0)"
              tooltipEvent="focus"
              [pTooltip]="'pre_simulator.habitual_housing_info' | translate"
              (click)="openToast('tooltip-habitualHousing')"
            >
              <img class="ico-info" src="assets/img/info.svg" title="Haz clic para más información" />
            </a>
          </div>
          <div class="switch-group">
            <label for="btn-is-subsidized-housing" class="switch-label">{{ 'pre_simulator.vpo' | translate }} </label>
            <label class="switch">
              <input type="checkbox" formControlName="isSubsidizedHousing" id="btn-is-subsidized-housing" />
              <span class="slider round">
                <span> {{ 'yes' | translate }} </span>
                <span> {{ 'no' | translate }} </span>
              </span>
            </label>
            <a
              id="tooltip-isSubsidizedHousing"
              class="icon-a"
              href="javascript:void(0)"
              tooltipEvent="focus"
              [pTooltip]="
                'La Vivienda de Protección Oficial es un tipo de vivienda promovida por la administración pública española'
                  | translate
              "
              (click)="openToast('tooltip-isSubsidizedHousing')"
            >
              <img class="ico-info" src="assets/img/info.svg" title="Haz clic para más información" />
            </a>
          </div>
        </div>
      </div>
      <!--  <div [ngClass]="{'col-12 col-lg-6 col-xl-4': isAdvanceSimulator, 'col-12 col-md-6 col-lg-3': !isAdvanceSimulator}">
  
          </div> -->

      @if (showButtonSimulate && !isAdvanceSimulator) {
        <div class="row d-flex justify-content-end col-12 form-btn-group">
          <button id="btn-simulate" class="btn btn-02 simulate-btn" type="submit" (click)="firstSimulate()">
            {{ 'pre_simulator.btn_simulate' | translate }}
          </button>
        </div>
      }
    </div>
  </form>
}
